// extracted by mini-css-extract-plugin
module.exports = {"group_container":"InputGroup_group_container__2KuRa","group_label":"InputGroup_group_label__2nayT"};